import _regeneratorRuntime from "/Users/xiaomingtongxue/Library/Mobile Documents/com~apple~CloudDocs/Documents/code/heart-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/xiaomingtongxue/Library/Mobile Documents/com~apple~CloudDocs/Documents/code/heart-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue";
import { watch, onErrorCaptured, onMounted, ref, nextTick } from "vue";
import { useRouter } from "vue-router";
import MyLoading from "@/components/MyLoading.vue";
export default {
  __name: 'App',
  setup: function setup(__props) {
    var router = useRouter();
    var APP_REVEAL_DELAY = 120;
    var revealApp = function revealApp() {
      var html = document.documentElement;
      html.classList.remove("font-loading");
      html.classList.add("fonts-ready");
    };
    var waitForFirstFrame = function waitForFirstFrame() {
      return new Promise(function (resolve) {
        return requestAnimationFrame(resolve);
      });
    };
    var waitForAppRevealDelay = function waitForAppRevealDelay() {
      return new Promise(function (resolve) {
        return setTimeout(resolve, APP_REVEAL_DELAY);
      });
    };
    onErrorCaptured(function () {
      // router.push({ name: "Error" });
    });
    var keepAlive = ref([]);
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var routes, myKeepAlive;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            routes = router.getRoutes();
            myKeepAlive = [];
            routes.forEach(function (item) {
              var _item$meta$keepAlive = item.meta.keepAlive,
                keepAlive = _item$meta$keepAlive === void 0 ? false : _item$meta$keepAlive;
              if (keepAlive) {
                myKeepAlive.push(item.name);
              }
            });
            keepAlive.value = myKeepAlive;
            _context.next = 6;
            return router.isReady();
          case 6:
            _context.next = 8;
            return nextTick();
          case 8:
            _context.next = 10;
            return waitForFirstFrame();
          case 10:
            _context.next = 12;
            return waitForAppRevealDelay();
          case 12:
            revealApp();
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    watch(function () {
      return router.currentRoute.value.path;
    }, function () {
      var _router$currentRoute$ = router.currentRoute.value.meta,
        _router$currentRoute$2 = _router$currentRoute$.title,
        title = _router$currentRoute$2 === void 0 ? "" : _router$currentRoute$2,
        _router$currentRoute$3 = _router$currentRoute$.isTransparent,
        isTransparent = _router$currentRoute$3 === void 0 ? false : _router$currentRoute$3;
      var body = document.getElementsByTagName("body");
      var html = document.getElementsByTagName("html");
      if (isTransparent) {
        html[0].style.backgroundColor = "rgba(0,0,0,0)";
        body[0].style.backgroundColor = "rgba(0,0,0,0)";
      } else {
        // html[0].style.backgroundColor = "rgba(255,255,255,1)";
        // body[0].style.backgroundColor = "rgba(255,255,255,1)";
      }
      document.title = title;
    }, {
      immediate: true
    });
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(function (_ref2) {
          var Component = _ref2.Component,
            route = _ref2.route;
          return [Component ? (_openBlock(), _createBlock(_Suspense, {
            key: 0
          }, {
            fallback: _withCtx(function () {
              return [_createVNode(MyLoading)];
            }),
            default: _withCtx(function () {
              return [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.meta.usePathKey ? route.path : undefined
              }))];
            }),
            _: 2
          }, 1024)) : _createCommentVNode("", true)];
        }),
        _: 1
      });
    };
  }
};